<template>
    <v-select
        solo
        append-icon=""
        class="input"
        :class="'js-sel-'+(company_type[0] ? company_type[0].id : 0)"
        :attach="'js-sel-'+(company_type[0] ? company_type[0].id : 0)"
        :items="company_type"
        :label="selected"
        :value="selected"
    >
        <template
            slot-scope="{ item, index }"
            slot="selection"
        >
            <span>{{ item.type }} </span>
        </template>
        <template #append>
          <v-icon aria-hidden="true" translate="no">
            expand_more
          </v-icon>
        </template>
        <v-list-tile-content slot-scope="data" slot="item" @click="click(data.item.type)">
            <div>
                {{ data.item.type }}
            </div>
        </v-list-tile-content>
    </v-select>
</template>

<script>
import {mapMutations} from 'vuex';

export default {
  props: {
    company_type: {
      type: Array,
    },
  },
  computed: {
    selected: {
      get() {
        let res;
        if (this.company_type.filter((x) => x.selected).length > 0) {
          res = this.company_type.filter((x) => x.selected)[0].type;
        } else if (this.company_type.length) {
          res = this.company_type[0].type;
        }

        return res || 'Выбрать';
      },
    },
  },

  methods: {
    ...mapMutations('company_profile/info', ['SET_TYPE_COMPANY']),
    click($event) {
      this.$emit('click', $event);
    },
    hideMulti() {
      this.$refs.multi.blur();
    },
  },
};
</script>

